export const gridTileColor = '#3d2963';
export const backgroundColor = '#57407c';
export const primaryFontColor = (opacity = 1) =>
  `rgba(255, 255, 255, ${opacity})`;
export const buttonHoverColor = '#d3386a';
export const modalTextColor = '#534648';
export const modalBackgroundColor = '#FFFFFF';
export const overlayBackgroundColor = '#000000';
export const gridOverlayBackground = '#412667b5';
export const highlightColor = '#E88A45';

export default {
  backgroundColor,
  gridTileColor,
  primaryFontColor,
  buttonHoverColor,
  modalTextColor,
  modalBackgroundColor,
  overlayBackgroundColor,
  gridOverlayBackground,
  highlightColor
};
